module.exports = __webpack_public_path__ + "img/experts2.6cdd65ae.png";